import { StrictMode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import '@ant-design/v5-patch-for-react-19';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import './global.css';

import ThemeProvider from './components/globals/ThemeProvider';
import { trpc, trpcReactClient } from './lib/trpc';
import Pages from './pages';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 0,
      staleTime: 0,
      refetchOnWindowFocus: false,
      retry: false
    },
    mutations: {
      gcTime: 0
    }
  }
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <trpc.Provider client={trpcReactClient} queryClient={queryClient}>
        <ThemeProvider>
          <BrowserRouter>
            <StrictMode>
              <Pages />
            </StrictMode>
          </BrowserRouter>
        </ThemeProvider>
      </trpc.Provider>
    </QueryClientProvider>
  );
}
